/* tslint:disable */
/* eslint-disable */
/**
 * Scality Guardian Backend
 *
 * The version of the OpenAPI document: 0.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Message model for chat conversations.
 * @export
 * @interface Message
 */
export interface Message {
    /**
     * 
     * @type {Date}
     * @memberof Message
     */
    timestamp: Date;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    role: MessageRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    content: string;
}


/**
 * @export
 */
export const MessageRoleEnum = {
    User: 'user',
    Assistant: 'assistant',
    Tool: 'tool'
} as const;
export type MessageRoleEnum = typeof MessageRoleEnum[keyof typeof MessageRoleEnum];


/**
 * Check if a given object implements the Message interface.
 */
export function instanceOfMessage(value: object): value is Message {
    if (!('timestamp' in value) || value['timestamp'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function MessageFromJSON(json: any): Message {
    return MessageFromJSONTyped(json, false);
}

export function MessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): Message {
    if (json == null) {
        return json;
    }
    return {
        
        'timestamp': (new Date(json['timestamp'])),
        'role': json['role'],
        'content': json['content'],
    };
}

export function MessageToJSON(json: any): Message {
    return MessageToJSONTyped(json, false);
}

export function MessageToJSONTyped(value?: Message | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'timestamp': ((value['timestamp']).toISOString()),
        'role': value['role'],
        'content': value['content'],
    };
}

